export default{
  facebookToEdit: {
    email_page: "",
    id: '',
    id_form: "",
    id_source: "",
    list_code: "",
  },
  loading: true,
  page: 0,
  size: 15,
  pagination: {
    current_page: 0,
    number_of_elements: 0,
    total_elements: 0,
    total_pages: 0
  },
  is_active: null,
  product_id: '',
  search_text: '',
  items: [],
  newForm: true
}


// WEBPACK FOOTER //
// ./src/store/modules/facebook/state.js